import "../OurStory/KeyExpertise.css";
import { DGShipping } from "../OurStory/KeyData";

const Card = ({ title, content, icon, animation }) => {
  return (
    <div className="cards-key" data-aos={animation}>
      <div id="icon-container">
        <i id="icon" className={icon}></i>
      </div>
      <div className="user-info">
        <h2 className="card-title">{title}</h2>
        <p className="card-content">{content}</p>
      </div>
    </div>
  );
};

const DGShippingService = () => {
  return (
    <>
      <div className="key-heading">
        <h3 style={{ fontSize: "25px", marginTop: "30px" }}>
          Our Range of DG Shipping Service
        </h3>
      </div>
      <div className="card-container">
        {DGShipping.map((card, index) => (
          <Card
            key={index}
            icon={card.icon}
            title={card.title}
            content={card.content}
            animation={card.animation}
          />
        ))}
      </div>
    </>
  );
};

export default DGShippingService;
